<script lang="ts" setup>
  import { useTitropEvents } from '@/composables/useTitropEvents.ts'
  import HotkeyHelp from '@/components/layout/helps/HotkeyHelp.vue'
  import TricksHelp from '@/components/layout/helps/TricksHelp.vue'
  import NotificationHelp from '@/components/layout/helps/NotificationHelp.vue'

  const showShortcutHelp = ref(false)

  onMounted(() => {
    useTitropEvents().hotkeyToggleHotkeyHelpDialog.on(() => (showShortcutHelp.value = !showShortcutHelp.value))
  })
</script>

<template>
  <Dialog
    v-model:visible="showShortcutHelp"
    header="Kurzhilfe">
    <div class="overflow-x-auto">
      <Tabs value="0">
        <TabList>
          <Tab value="0">Tastenkürzel</Tab>
          <Tab value="1">Tipps & Tricks</Tab>
          <Tab value="2">Benachrichtigungen</Tab>
        </TabList>
        <TabPanels>
          <TabPanel value="0"><HotkeyHelp /></TabPanel>
          <TabPanel value="1"><TricksHelp /></TabPanel>
          <TabPanel value="2"><NotificationHelp /></TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  </Dialog>
</template>
